'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$43() {
  this.biA = null;
  this.biB = false;
}
export { $c_Lpresto_PrestoRouter$$anon$43 as $c_Lpresto_PrestoRouter$$anon$43 };
$p = $c_Lpresto_PrestoRouter$$anon$43.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$43;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$43() {
}
export { $h_Lpresto_PrestoRouter$$anon$43 as $h_Lpresto_PrestoRouter$$anon$43 };
$h_Lpresto_PrestoRouter$$anon$43.prototype = $p;
$p.bW = (function() {
  if ((!this.biB)) {
    this.biA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.biB = true;
  }
  return this.biA;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$43 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$43, "presto.PrestoRouter$$anon$43", ({
  Oa: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$43 as $d_Lpresto_PrestoRouter$$anon$43 };
//# sourceMappingURL=presto.-Presto-Router$$anon$43.js.map
